import { getRequestAuthPayload } from '@helpers/getRequestAuth';
import { queryOptions } from '@tanstack/react-query';
import axios from 'axios';

import type { JSONSchema } from '../../@types/types';

import type { QueryFactory } from './factory.types';

export const fetchSchema = async (): Promise<JSONSchema> => {
  const networkPayload = await getRequestAuthPayload({
    method: 'get',
    url: `/schema`,
  });

  const response = await axios(networkPayload);
  return response.data;
};

export const schemaQueries = {
  get: () =>
    queryOptions({
      queryKey: ['schema'] as const,
      queryFn: fetchSchema,
      staleTime: Infinity, // schema never changes mid-session
    }),
} satisfies QueryFactory;
